import _ from "lodash"

/**
 * Determine if we need to process a group of edges.
 *
 * @param edges {array} that have the same source
 * @return {boolean} true if both edges are conditions, and none of them are virtual
 */
const canGuess = edges => {
  return (
    edges.every(e => e.condition != null) &&
    !edges.some(e => e.v.includes("virtual"))
  )
}

/**
 * Determine the order edges have been laid out in based on their position in
 * the layout.
 *
 * @param edges {array} where both are edges for actual nodes (non virtual)
 * @return {string} human readable representation of edge order from left to right
 */
export const guessOrder = edges => {
  const yes = edges.find(e => e.condition == "yes")
  const no = edges.find(e => e.condition == "no")

  return yes?.points[0].x < no?.points[0].x ? "yes-no" : "no-yes"
}

/**
 * Iterates over edges produced from Workflow::Graph.as_json. Edges are first
 * grouped by their source, if the groups of edges consist of all conditions and
 * no virtual edges, we need to guess the order they've been laid out in. This
 * is necessary to correct label styles and avoid crossed conditional lines.
 *
 * @param data {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout  }
 * @return {object} { roots: [JSON], nodes: [JSON], edges: [JSON], scope: HTMLElement, layout: Layout  }
 */
export const determineConditionOrder = data => {
  const groups = _.groupBy(data.edges, "v")

  _.forEach(groups, (edges, source) => {
    if (canGuess(edges)) {
      const order = guessOrder(edges)
      const parent = data.layout.graph.node(source)

      parent.element.dataset.conditionOrder = order
      parent.conditionOrder = order
    }
  })

  return {
    ...data
  }
}

